import { render, staticRenderFns } from "./SlidePlaceholder.vue?vue&type=template&id=dcb39c3e&scoped=true&"
import script from "./SlidePlaceholder.vue?vue&type=script&lang=js&"
export * from "./SlidePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./SlidePlaceholder.vue?vue&type=style&index=0&id=dcb39c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb39c3e",
  null
  
)

export default component.exports